import gql from "graphql-tag";
const pingAPIQuery = gql(` 
query ping {
	pingAPI(id: "ping") {id}
	}
`)
export default pingAPIQuery;